<template>
    <div>
        <!--<div class="item-title">成绩管理</div>-->
        <!--<div style="text-align: left;">
            <el-button @click="download">导出成绩</el-button>
        </div>-->
        <div class="list-title">
            <div></div>
            <div>学生姓名</div>
            <div>班级</div>
            <div>交卷时间</div>
            <div>分数</div>
            <div>修改后分数</div>
            <div></div>
        </div>
        <div v-if="list.length===0">暂无数据</div>
        <div class="list" v-for="(l,index) in list" :class="l.status===0?'color-orange':''">
            <div>{{index+1}}</div>
            <div>{{l.examinerName}}</div>
            <div>{{l.gradeName}}</div>
            <div>{{l.answerTime}}</div>
            <div v-if="l.editable" style="text-align:center;"><input type="text" @blur.prevent="edit(l)" v-model="l.score"></input></div>
            <div  v-else >{{l.score}}</div>
            <div>{{l.updateScore}}</div>
            <div>
                <button class="check-btn" @click="openInfo(l)">查看试卷</button>
                <button class="check-btn" @click="editScore(l)">修改分数</button>
            </div>
        </div>
        <Pagination
                :size=total
                :pageLimit=pageInfo.pageObject.pageSize
                style="margin:20px 0"
                v-on:changeCurrent="changeCurrent"></Pagination>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        name: "WorkResult",
        components:{Pagination},
        data(){
            return{
                list: [],
                pageInfo:{
                    pageObject:{
                        currentPage:1,
                        pageSize: 8
                    },
                    model:{
                        userId:this.$store.getters.getToken.userId
                    }
                },
                total:0,
            }
        },
        created() {
            this.getAllResult(this.pageInfo);
        },
        methods:{
            openInfo(l){
                window.open("/ViewExam/"+l.id);
            },
            getAllResult(pageInfo){
                this.$json("/training/job/page","POST",pageInfo).then(res=>{
                    this.list=res.data.data;
                    this.total = res.data.totalCount;
                })
            },
            editScore(l){
                this.$nextTick(function () {
                    this.$set(l,'editable',true);
                });
            },
            edit(l){
                let putData = {id:l.id,updateScore:parseInt(l.score),mender:this.$store.getters.getToken.userId};
                this.$put("/paperRecord/score",putData).then(res=>{
                    if(res.code===200){
                        this.$message("修改成功");
                        this.$nextTick(function () {
                            this.$set(l,'editable',false);
                        });
                        this.getAllResult();
                    }
                })
            },
            changeCurrent(data){
                this.pageInfo.pageObject.currentPage = data;
                this.getAllResult(this.pageInfo);
            },
            download(){
                let postData={model:{creator:this.$store.getters.getToken.userId}};
                this.$json("/paperRecord/export","POST",postData).then(res=>{
                    let url =this.serverIp+"/"+res.data; //window.URL.createObjectURL(this.serverIp+res.data);
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    //a.download = "成绩.xlsx"; //命名下载名称
                    a.click(); //点击触发下载
                    window.URL.revokeObjectURL(url);
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
    .list:nth-child(even), .list-title {
        background-color: #edf5ff;
    }
</style>
